import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const sendForAdminApproval = ({shumaID}) => {
  return (dispatch) => {
    const data = {shumaID: parseInt(shumaID, 10)};

    return axios.post(api.SEND_FOR_ADMIN_APPROVAL, data)
      .then((response) => {
        const {errorCode} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);
      })
  };
};
